import { FLOORPLANS_KEY } from '@domain/floorplans';
import { UseMutation, useMutationWrapper } from '@hooks/useMutationWrapper';
import { unarchiveFloorplan } from '@services/floorplans/floorplansService';
import { useQueryClient } from 'react-query';

const useUnarchiveFloorplan = (
  venueId: string,
  buildingId: string
): UseMutation<void, Error, string, unknown> => {
  const queryClient = useQueryClient();

  return useMutationWrapper<void, Error, string>(
    (floorplanId) => unarchiveFloorplan(floorplanId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(FLOORPLANS_KEY(venueId, buildingId));
      }
    }
  );
};

export { useUnarchiveFloorplan };
